import React from 'react';

interface FeatureLockedPageProps {
    featureName: string;
    planName?: string;
}

const FeatureLockedPage: React.FC<FeatureLockedPageProps> = ({ featureName, planName = 'current' }) => {
    return (
        <div className="flex items-center justify-center py-12 px-4 bg-gray-50/50 rounded-3xl border border-dashed border-gray-200">
            <div className="max-w-md w-full text-center space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
                <div className="relative inline-block">
                    <div className="w-20 h-20 bg-gradient-to-br from-indigo-50/50 to-blue-50/50 rounded-2xl flex items-center justify-center mx-auto border border-white/60">
                        <svg
                            className="w-10 h-10 text-indigo-400 opacity-60"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                            />
                        </svg>
                    </div>
                    <div className="absolute -top-2 -right-2 bg-indigo-600 shadow-md rounded-full px-2 py-0.5 border border-indigo-500 font-black text-[9px] text-white tracking-tighter uppercase italic">
                        PRO
                    </div>
                </div>

                <div className="space-y-3">
                    <h2 className="text-2xl font-black text-gray-900 tracking-tight italic uppercase">
                        {featureName} Upgrade Required
                    </h2>
                    <p className="text-gray-500 font-medium text-sm leading-relaxed px-4">
                        The <span className="text-gray-900 font-bold uppercase">{featureName}</span> suite is part of our premium ecosystem.
                        It is not available on the <span className="bg-indigo-50 text-indigo-600 px-2 py-0.5 rounded-md font-bold italic lowercase">{planName}</span> plan.
                    </p>
                </div>



                <div className="text-[10px] text-gray-400 font-medium px-8 italic">
                    Please contact your administrator to discuss upgrading your gym's subscription to access this feature.
                </div>
            </div>
        </div>
    );
};

export default FeatureLockedPage;
